import { render, staticRenderFns } from "./DoctorStatistics.vue?vue&type=template&id=06c3d3ec&scoped=true&"
import script from "./DoctorStatistics.vue?vue&type=script&lang=js&"
export * from "./DoctorStatistics.vue?vue&type=script&lang=js&"
import style1 from "./DoctorStatistics.vue?vue&type=style&index=1&id=06c3d3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3d3ec",
  null
  
)

export default component.exports